import { AppRouteProps } from "@bsm/component";
import UserAuthContainer from "./container/UserAuthContainer";
import { AuthRoutes } from "@bsm/login";


export const UserAuthRoutes: Array<AppRouteProps> = [
    {
        title: "Auth.Title",
        path: "",
        element: <UserAuthContainer />,
        children: [
            ...AuthRoutes,
        ]
    },
];
